import { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';

// components
import { notification } from 'antd';
import { TotalNumbers } from './total-numbers';
import { Map } from './map';

// services
import * as NewYearService from '../../../../services/bb-api/new-year';

export const NewYear: React.FC = () => {
  const [mapData, setMapData] = useState<any[]>([]);

	const getData = useCallback(() => {
		try {
			NewYearService.postLocations().then(setMapData);
		} catch (error) {
			const message = 'Der skete en fejl';
			notification.error({ message });
		}
	}, [])

	useEffect(() => {
		getData();
		const intervalTime = 60 * 1000 // 1 min
		const intervalId = setInterval(getData, intervalTime)
		return () => clearInterval(intervalId)
	}, [getData]);

	return (
    <StyledContainer>
      <TotalNumbers />
      <Map data={mapData} />
		</StyledContainer>
	);
};

const StyledContainer = styled.main`
	background-image: url('https://filer.boblberg.dk/Assets/Img/nytaarsvenner/nytaarsvenner-dashboard-bg.jpg');
	background-repeat: no-repeat;
	background-color: #1a202c;
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	grid-template-rows: 350px 1fr;
	grid-template-areas:
		'total total total'
		'rk-match map online';

	color: #333333;
		
	.map-container { grid-area: map }
	.total-container { grid-area: total }

	::-webkit-scrollbar {
		display: none;
	}
`;
